import { Column } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled from "styled-components";

import { ReasonsChecklist } from "./ReasonsChecklist";

interface IProps {
  checkedReasons: string[];
  setCheckedReasons: (checked: string[]) => void;
}

export const TellUsMore: React.FC<IProps> = ({
  checkedReasons,
  setCheckedReasons,
}) => {
  return (
    <Wrapper>
      <TellUsMoreTitle />
      <ReasonsChecklist
        checked={checkedReasons}
        setChecked={setCheckedReasons}
      />
    </Wrapper>
  );
};

const TellUsMoreTitle: React.FC = () => (
  <Typography
    variant="paragraphSansMedium"
    style={{ marginTop: getSpacing("4x") }}
  >
    <StrictLocalMsg
      defaultMessage="Help us improve by selecting all that apply:"
      description={{
        text: "Title for the CSAT reasons checklist",
        img: "https://cdn.faire.com/fastly/fcf3c31b3c258208fe766b50695e3fe8b745477b0b851f3fa9224512c445fb8e.png",
      }}
    />
  </Typography>
);

const Wrapper = styled(Column).attrs({ gap: "1x" })``;
